// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ellr","col":"styles_col__2K0db"};